import fetchPost from '@/api/http.js'

export default {
    actions: {
        getUnOrderListApi({}, data) {
            return fetchPost('/saas/shipperOrderController/queryUnsettledShipperOrder', data)
        },
        uploadFileApi({}, data) {
            return fetchPost('/saas/shipperOrderController/queryOrderAndUploadFile', data)
        },
        downLoadFileApi({}, data) {
            return fetchPost('/saas/shipperOrderController/downLoadFile', data)
        },
    }
}
